import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EditorialGridProps {
    children: ReactNode
    className?: string
    as?: 'div' | 'ul' | 'ol' | 'section'
}

/** 4 columns on mobile, 12 from tablet up. Children place themselves with col-span utilities. */
const EditorialGrid: FC<EditorialGridProps> = ({ children, className, as: Tag = 'div' }): ReactNode => {
    return (
        <Tag className={cn('grid grid-cols-4 gap-x-4 sm:gap-x-6 md:grid-cols-12 lg:gap-x-8', className)}>
            {children}
        </Tag>
    )
}

export default EditorialGrid
